import * as React from 'react';
import { Util, Tooltip } from '@grandvisionhq/common';

const BannerTooltip = ({ className , tooltip  })=>{
    const isTouch = React.useMemo(()=>Util.isTouchDevice()
    , []);
    const placement = isTouch ? 'top-end' : 'top';
    return /*#__PURE__*/ React.createElement(Tooltip, {
        renderInPortal: true,
        className: className,
        id: tooltip.text,
        message: tooltip.text,
        label: tooltip.title,
        theme: tooltip.textColor,
        boundariesElement: "viewport",
        renderLabel: true,
        placement: placement,
        preventClickDefault: true
    });
};

export { BannerTooltip };
//# sourceMappingURL=BannerTooltip.js.map
